"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _axios = _interopRequireDefault(require("axios"));

var _formik = require("formik");

var _reactToastify = require("react-toastify");

var Yup = _interopRequireWildcard(require("yup"));

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledText = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"])));

var Schema = function Schema(t) {
  return Yup.object().shape({
    code: Yup.string().min(6, t.confirmPhoneValidation).max(6, t.confirmPhoneValidation)
  });
};

var ConfirmPhoneNumber = function ConfirmPhoneNumber(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      onCancel = _ref.onCancel;

  if (!translations) {
    translations = _defaultTranslations.default;
  }

  var location = (0, _reactRouterDom.useLocation)();

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var isFromSignupPage = (location === null || location === void 0 ? void 0 : location.search.indexOf("signup")) > -1; // const onLocationSuccess = ({ country, dialingCode }) => {
  //   setState({ ...state, location: country, dialingCode });
  // };
  //
  // useIpLocation(onError, onLocationSuccess);

  var validate = function validate(values) {
    var errors = {};

    if (!/^[0-9]*$/.test(values.code)) {
      errors.code = translations.confirmPhoneValidationNumbers;
    }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;

    _axios.default.post("/verification/mobile/verify", values).then(function (_ref3) {
      var data = _ref3.data;
      onSuccess(isFromSignupPage);
      setSubmitting(false);

      _reactToastify.toast.success(translations.confirmPhoneSuccess);

      window.xtremepush("tag", "MobileVerified", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
    }).catch(function (_ref4) {
      var _rest$response, _rest$response$data;

      var error = _ref4.error,
          rest = _objectWithoutProperties(_ref4, ["error"]);

      setSubmitting(false);

      if (rest !== null && rest !== void 0 && (_rest$response = rest.response) !== null && _rest$response !== void 0 && (_rest$response$data = _rest$response.data) !== null && _rest$response$data !== void 0 && _rest$response$data.message) {
        _reactToastify.toast.error(rest.response.data.message);

        onError(error);
      } else {
        onError(error);
      }
    });
  };

  var sendVerificationCode = function sendVerificationCode() {
    _axios.default.post("/verification/mobile/send").then(function (_ref5) {
      var data = _ref5.data;

      _reactToastify.toast.success(translations.confirmPhoneCodeSent);
    }).catch(function (_ref6) {
      var error = _ref6.error;

      _reactToastify.toast.error(translations.confirmPhoneCodeError);

      onError(error);
    });
  };

  (0, _react.useEffect)(function () {
    sendVerificationCode();
  }, []);
  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "registration_mobile_verification", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Alert, {
      margin: "0 0 1rem",
      children: translations.confirmPhoneMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
      validationSchema: Schema(translations),
      initialValues: {
        code: ""
      },
      validate: validate,
      onSubmit: onSubmit,
      children: function children(_ref7) {
        var isValid = _ref7.isValid,
            values = _ref7.values,
            errors = _ref7.errors,
            touched = _ref7.touched,
            dirty = _ref7.dirty,
            handleChange = _ref7.handleChange,
            handleBlur = _ref7.handleBlur,
            handleSubmit = _ref7.handleSubmit,
            isSubmitting = _ref7.isSubmitting,
            setSubmitting = _ref7.setSubmitting;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_formik.Form, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            isSmall: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
              isSmall: true,
              value: values.code,
              isError: errors.code,
              onChange: handleChange,
              name: "code",
              type: "tel",
              placeholder: translations.enterReceivedCode
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
            isVisible: errors.code,
            children: errors.code
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            isLoading: isSubmitting,
            disabled: !isValid || !dirty || errors.code,
            type: "submit",
            style: {
              marginBottom: "1rem"
            },
            children: translations.verifyNow
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            type: "button",
            onClick: function onClick() {
              return sendVerificationCode();
            },
            style: {
              marginBottom: "1rem"
            },
            children: translations.resendCode
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            type: "button",
            style: {
              marginBottom: "1rem"
            },
            onClick: function onClick() {
              return onCancel(isFromSignupPage);
            },
            children: isFromSignupPage ? translations.confirmPhoneLater : translations.cancel
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Alert, {
            isDanger: true,
            children: translations.confirmPhoneWarning
          })]
        });
      }
    })]
  });
};

var _default = ConfirmPhoneNumber;
exports.default = _default;